// extracted by mini-css-extract-plugin
export default {"list":"style_list__EWKNY","item":"style_item__Q+rSS","image":"style_image__q+FLi"};